module.exports = __webpack_public_path__ + "img/115-1150152_default-profile-picture-avatar-png-green.0a5e7a1f.png";